import { makeStyles } from "@material-ui/core";

export const useCreateActivityDialogStyles = makeStyles((theme) => ({
    dialogActions: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: theme.spacing(2, 3),
    },
    rightButtonContainer: {
        marginLeft: 'auto',
    },
    warningAlert: {
        flex: 1,
        marginRight: theme.spacing(2),
    },
    backButton: {
        fontSize: '1rem',
        fontWeight: 500,
        padding: theme.spacing(1, 2),
        textTransform: 'none',
        color: theme.palette.primary.main,
        '& .MuiButton-startIcon': {
            marginRight: theme.spacing(1),
        },
    },
    continueButton: {
        fontSize: '1rem',
        fontWeight: 500,
        padding: theme.spacing(1, 2),
        textTransform: 'none',
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        '&:hover': {
            backgroundColor: theme.palette.primary.dark,
        },
        '& .MuiButton-endIcon': {
            '& path, & svg': {
                fill: theme.palette.common.white,
                color: theme.palette.common.white,
            },
        },
    },
    dialogContent: {
        minHeight: '400px',
        paddingTop: theme.spacing(2),
    },
    stepperContainer: {
        marginBottom: theme.spacing(4),
        paddingBottom: theme.spacing(3),
        fontFamily: theme.typography.fontFamily,
        borderBottom: `1px solid ${theme.palette.divider}`,
        display: 'flex',
        justifyContent: 'center',
        '& .MuiStepper-root': {
            padding: 0,
        },
        '& .MuiStep-root': {
            padding: theme.spacing(0, 2),
        },
        '& .MuiStepLabel-root': {
            flexDirection: 'row',
            alignItems: 'center',
        },
        '& .MuiStepLabel-iconContainer': {
            paddingRight: theme.spacing(1.5),
            marginBottom: 0,
        },
        '& .MuiStepIcon-root': {
            width: '44px',
            height: '44px',
            borderRadius: '50%',
            color: theme.palette.divider,
            '&.Mui-active': {
                color: theme.palette.primary.main,
            },
            '&.Mui-completed': {
                color: theme.palette.divider,
            },
        },
        '& .MuiStepIcon-text': {
            fill: theme.palette.text.secondary,
            fontWeight: 500,
            fontSize: '1rem',
            fontFamily: theme.typography.fontFamily,
        },
        '& .Mui-active .MuiStepIcon-text': {
            fill: theme.palette.common.white,
        },
        '& .MuiStepLabel-labelContainer': {
            textAlign: 'left',
        },
        '& .MuiStepLabel-label': {
            fontSize: '0.813rem',
            fontWeight: 600,
            color: theme.palette.text.secondary,
            lineHeight: 1.3,
            fontFamily: theme.typography.fontFamily,
        },
        '& .MuiStepConnector-root': {
            display: 'none',
        },
    },
    stepSubtitle: {
        fontSize: '0.688rem',
        color: theme.palette.text.secondary,
        marginTop: theme.spacing(0.25),
        fontWeight: 400,
        fontFamily: theme.typography.fontFamily
    },
}));
